class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
      panelWrapper: this.querySelector(".disclosure__list-wrapper"),
    };
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    
    if (isSafari) {
      this.elements.button.addEventListener("blur", this.closeSelector.bind(this));
      this.elements.button.addEventListener("mousedown", this.openSelector.bind(this));
    } else {
      this.elements.button.addEventListener("click", this.openSelector.bind(this));
      this.elements.button.addEventListener("focusout", this.closeSelector.bind(this));
    }
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
    this.onBodyClick = this.handleBodyClick.bind(this);
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target != this && !target.closest("localization-form")) {
      this.hidePanel();
    }
  }

  hidePanel() {
    document.body.removeEventListener("click", this.onBodyClick);
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.button.classList.remove("opened");
    this.elements.panelWrapper.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    if(this.elements.button.getAttribute('aria-expanded') == 'false') return;

    this.hidePanel();
    event.stopPropagation();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    if (this.elements.button.classList.contains("opened")) {
      this.hidePanel();
    } else {
      document.body.addEventListener("click", this.onBodyClick);
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
      this.elements.button.focus();
      this.elements.panelWrapper.toggleAttribute('hidden');
      for (var item of document.querySelectorAll(".button-localization")) {
        item.classList.remove("opened");
      }
      requestAnimationFrame(() => {
        this.elements.button.classList.add("opened");
      });
    }
  }

  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define("localization-form", LocalizationForm);

document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('localization-form');

  const closeAll = () => {
    document.querySelectorAll('localization-form details[open]').forEach((d) => {
      d.removeAttribute('open');
    });
  };

  forms.forEach((form) => {
    const details = form.querySelector('details');
    if (!details) return;

    const summary = details.querySelector('summary');
    if (summary) summary.classList.add('tl-localization-trigger');

    // 1) 点击空白处：收起（desktop + mobile 都生效）
    document.addEventListener(
      'click',
      (e) => {
        if (!details.hasAttribute('open')) return;
        if (!form.contains(e.target)) closeAll();
      },
      true
    );

    // 2) 滚动页面：收起（解决你说的“未选择时滚动导致状态变白/乱跳”）
    window.addEventListener(
      'scroll',
      () => {
        if (details.hasAttribute('open')) closeAll();
      },
      { passive: true }
    );

    // 3) 用户点了某个币种（还没刷新前就先给到高亮 + 收起）
    // 用 pointerdown 比 click 更早触发，能在页面刷新前让用户看到反馈
    form.addEventListener(
      'pointerdown',
      (e) => {
        const optionEl = e.target.closest('[data-value], a, button, input[type="radio"]');
        if (!optionEl) return;

        // 标记当前触发器“已激活”（用于 summary 高亮）
        if (summary) summary.classList.add('tl-is-active');

        // 给被点中的那一项加高亮 class（兼容没有 aria-current 的主题）
        form.querySelectorAll('.tl-is-selected').forEach((n) => n.classList.remove('tl-is-selected'));
        const item = optionEl.closest('li') || optionEl;
        item.classList.add('tl-is-selected');

        // 立刻收起菜单（不弹窗）
        closeAll();
      },
      true
    );
  });
});
document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('localization-form');

  const getOpenController = (form) => {
    // Shopify 常见结构：details/summary
    const details = form.querySelector('details');
    const summary = details ? details.querySelector('summary') : null;

    // 兜底：有些主题用 aria-expanded 控制
    const trigger =
      summary ||
      form.querySelector('[aria-controls][aria-expanded]') ||
      form.querySelector('button[aria-expanded]') ||
      form.querySelector('summary');

    // 面板：兜底找可能的 list
    const panel =
      form.querySelector('[data-localization-panel]') ||
      form.querySelector('.disclosure__list') ||
      form.querySelector('.localization-selector__list');

    return { details, trigger, panel };
  };

  const closeForm = (form) => {
    const { details, trigger } = getOpenController(form);
    if (details) details.removeAttribute('open');
    if (trigger) {
      trigger.classList.remove('tl-open');
      trigger.setAttribute('aria-expanded', 'false');
    }
  };

  const closeAll = () => {
    document.querySelectorAll('localization-form').forEach(closeForm);
  };

  forms.forEach((form) => {
    const { details, trigger, panel } = getOpenController(form);
    if (!trigger) return;

    // 标记 trigger，给 CSS 用
    trigger.classList.add('tl-localization-trigger');

    // 1) 打开/关闭时：只在 open 状态加下划线
    const syncOpenState = () => {
      const isOpen =
        (details && details.hasAttribute('open')) ||
        trigger.getAttribute('aria-expanded') === 'true';

      if (isOpen) trigger.classList.add('tl-open');
      else trigger.classList.remove('tl-open');
    };

    // details 结构
    if (details) {
      details.addEventListener('toggle', syncOpenState);
    } else {
      // aria-expanded 结构
      trigger.addEventListener('click', () => {
        // 让主题自身去开关，我们只同步样式
        setTimeout(syncOpenState, 0);
      });
    }

    // 2) 点空白处：收起（desktop + mobile）
    document.addEventListener(
      'click',
      (e) => {
        const isOpen =
          (details && details.hasAttribute('open')) ||
          trigger.getAttribute('aria-expanded') === 'true';
        if (!isOpen) return;

        if (!form.contains(e.target)) closeForm(form);
      },
      true
    );

    // 3) 滚动：收起（解决你说的“点开未选就滚动导致状态变白/残留”）
    window.addEventListener(
      'scroll',
      () => {
        const isOpen =
          (details && details.hasAttribute('open')) ||
          trigger.getAttribute('aria-expanded') === 'true';
        if (isOpen) closeForm(form);
      },
      { passive: true }
    );

    // 4) 选择币种：立即高亮被点项 + 收起（不弹窗）
    form.addEventListener(
      'pointerdown',
      (e) => {
        // 找到用户点到的“选项”
        const opt =
          e.target.closest('[data-value]') ||
          e.target.closest('[data-localization-item]') ||
          e.target.closest('a') ||
          e.target.closest('button') ||
          e.target.closest('input[type="radio"]');

        if (!opt) return;

        // 清理旧选中高亮（兜底）
        form.querySelectorAll('.tl-is-selected').forEach((n) => n.classList.remove('tl-is-selected'));

        // 给本次点击项做轻量高亮（在刷新前也能看到反馈）
        const item = opt.closest('li') || opt;
        item.classList.add('tl-is-selected');

        // 收起菜单
        closeForm(form);
      },
      true
    );

    // 初始化同步一次
    syncOpenState();
  });
});
// 4) 选择币种：只负责收起（不加高亮块）— 安全版
document.querySelectorAll('localization-form').forEach((form) => {
  form.addEventListener(
    'click',
    (e) => {
      const isOptionClick =
        e.target.closest('.disclosure__item') ||
        e.target.closest('.localization-selector__item') ||
        e.target.closest('[data-value]') ||
        e.target.closest('a') ||
        e.target.closest('button') ||
        e.target.closest('input[type="radio"]');

      if (!isOptionClick) return;

      // closeForm 只在第二段 DOMContentLoaded 里定义过，所以这里要确保存在
      if (typeof closeForm === 'function') closeForm(form);
    },
    true
  );
});

// Close localization dropdown on outside click / ESC (safe, no layout changes)
(() => {
  if (window.__TL_LOC_CLOSE_INIT__) return;
  window.__TL_LOC_CLOSE_INIT__ = true;

  const closeAll = (exceptForm) => {
    document.querySelectorAll('localization-form details[open]').forEach((d) => {
      const form = d.closest('localization-form');
      if (!exceptForm || form !== exceptForm) d.open = false;
    });
  };

  // 点击页面空白处：收起
  document.addEventListener('click', (e) => {
    const form = e.target.closest('localization-form');
    closeAll(form || null);
  }, true);

  // ESC：收起
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll(null);
  });
})();
